import React, { useState, useEffect } from "react";
import { Box, TextField, Autocomplete, Grid } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useDispatch, useSelector } from "react-redux";
import { selectProdotti } from "../../features/Prodotti/prodottiSlice";
import { resetFormData, resetFormSubmit, selectVarientaDelluva, selectVarientaVigneto, storeFormData } from "../../features/produzioniFormData/produzioniFormDataSlice";
import produzioniFormAPI from "../../services/produzioniFormApi";
import { fetchProdotti } from "../../features/Prodotti/prodottiThunk";
import { fetchProduzioineVarientaDelluva, fetchProduzioineVarientaVigneto } from "../../features/produzioniFormData/produzioniFormDataThunk";
dayjs.locale('it');

const InputFeild = ({ formData, setFormData }) => {
  const dispatch = useDispatch();
  const productOptions = useSelector(selectProdotti);
  const varieta_dell_uva = useSelector(selectVarientaDelluva);
  const varieta_vigento = useSelector(selectVarientaVigneto);
 
  useEffect(() => {
    dispatch(fetchProdotti());
    dispatch(fetchProduzioineVarientaDelluva());
    dispatch(fetchProduzioineVarientaVigneto());
  }, [dispatch]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value
    }));
  };
  
  return (
    <Box className="InformazioniSection">
      <p className="sectiontitleSmall">Informazioni preliminari</p>
      <Grid container spacing={1}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
          <Grid size={1.25}>
            <DatePicker
              className="datePickerField"
              label="Data inizio"
              format="YYYY-MM-DD"
              value={formData.date_Start ? dayjs(formData.date_Start) : null}
              onChange={(newValue) =>
                handleChange("date_Start", newValue ? dayjs(newValue).format("YYYY-MM-DD") : null)
              }
              slotProps={{ textField: { size: "small" } }}
            />
          </Grid>
          <Grid size={1.25}>
            <DatePicker
              className="datePickerField"
              label="Data fine"
              format="YYYY-MM-DD"
              value={formData.date_end ? dayjs(formData.date_end) : null}
              onChange={(newValue) =>
                handleChange("date_end", newValue ? dayjs(newValue).format("YYYY-MM-DD") : null)
              }
              slotProps={{ textField: { size: "small" } }}
            />
          </Grid>
        </LocalizationProvider>
        <Grid size={1.7}>
          <Autocomplete
            options={productOptions}
            // value={productOptions.find((prodo)=> prodo.id === formData.prodotto_id)?.commercial_name}
            getOptionLabel={(option) => option.commercial_name || ''}
            value={productOptions.find((option) => option.id == formData.prodotto_id) || null}
            onChange={(event, newValue) => handleChange("prodotto_id", newValue?.id)}
            renderInput={(params) => (
              <TextField className="customTextBox autoCompleteTextBox" {...params} label="Prodotto" size="small" />
            )}
          />
        </Grid>
        <Grid size={1.7}>
          <Autocomplete
            options={varieta_dell_uva}
            value={formData.varieta_dell_uva}
            onChange={(event, newValue) => handleChange("varieta_dell_uva", newValue)}
            renderInput={(params) => (
              <TextField className="customTextBox autoCompleteTextBox" {...params} label="Varietà dell'uva" size="small" />
            )}
          />
        </Grid>
        <Grid size={1.7}>
          <Autocomplete
            options={varieta_vigento}
            value={formData.varieta_vigento}
            onChange={(event, newValue) => handleChange("varieta_vigento", newValue)}
            renderInput={(params) => (
              <TextField className="customTextBox autoCompleteTextBox" {...params} label="Varietà del Vigneto" size="small" />
            )}
          />
        </Grid>
        <Grid size={1.7}>
          <TextField
            className="customTextBox"
            label="Stato fenologico"
            value={formData.stato}
            onChange={(e) => handleChange("stato", e.target.value)}
            size="small"
          />
        </Grid>
        <Grid size={1}>
          <TextField
            className="customTextBox"
            label="° Brix"
            value={formData.brix}
            onChange={(e) => handleChange("brix", e.target.value)}
            size="small"
          />
        </Grid>
        <Grid size={1.7}>
          <TextField
            className="customTextBox"
            label="Acidità tot. (G/l)"
            value={formData.acidity}
            onChange={(e) => handleChange("acidity", e.target.value)}
            size="small"
          />
        </Grid>
      </Grid>
    </Box>
  );
};
export default InputFeild;